import React from 'react';
import ListItem from "@material-ui/core/ListItem";
import css from "../../SidebarMenu.module.css";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import NotificationsIcon from '@material-ui/icons/Notifications';
import ListItemText from "@material-ui/core/ListItemText";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import IconButton from "@material-ui/core/IconButton";
import {connect} from "react-redux";
import EditIcon from '@material-ui/icons/Edit';
import {showEditingAlert} from "../../../../store/modalsSlice";
import {parseCommaPokemonIdsIntoArray} from "../../../../utils";

const AlertList = (props) => {
	const showPokemonImages = (pokemons) => {
		let extra = null;
		const max = 7;

		if( pokemons.length > max ) {
			extra = <span style={{fontSize: '80%'}}>+{pokemons.length-max+1}…</span>;
			pokemons = pokemons.slice(0,max-1);
		}

		const result = pokemons.map(pokemon => (
			<img key={'pokemon-' + pokemon} alt='Pokemon' height='24' src={'https://www.a2pogo.com/images/pokemon/icons-4/' + pokemon + '.png'} />
		));
		if( extra )
			result.push(extra);

		return result;
	};

	const showAlerts = alerts => {
		const qualityLevels = {"0": "All", "20": "Okay", "40": "Good", "60": "Great", "80": "Best"};
		return alerts.map(alert => {
			const pokemonIds = parseCommaPokemonIdsIntoArray(alert.pokemon_ids);
			let text = '';

			if( alert.min_quality )
				text = qualityLevels[alert.min_quality] + " Quality";

			if( alert.min_iv ) {
				if( text ) text += ', ';
				text += "Min IV: " + Math.round(alert.min_iv) + "%"
			}

			return (
				<ListItem className={css.SidebarItemNested} key={'alert-' + alert.alert_id}>
					<ListItemIcon>
						<NotificationsIcon />
					</ListItemIcon>
					<ListItemText primary={showPokemonImages(pokemonIds)}
								  secondary={text}
					/>
					<ListItemSecondaryAction>
						<IconButton onClick={() => props.showEditingAlert(alert)} edge="end" aria-label="edit">
							<EditIcon />
						</IconButton>
					</ListItemSecondaryAction>
				</ListItem>
			);
		});
	};

	return (
		<>
			{showAlerts(props.alerts)}
		</>
	);
};

const mapDispatchToProps = (dispatch) => {
	return {
		showEditingAlert: (alert) => dispatch(showEditingAlert(alert))
	};
};

export default connect(null,mapDispatchToProps)(AlertList);